import React from 'react';
import { useStyletron } from 'baseui';
import { Heading, HeadingLevel } from 'baseui/heading';
export const FormHeader = ({
  children,
  level,
  required
}) => {
  const [css] = useStyletron();
  return <HeadingLevel>
      <Heading data-testid="form-header" styleLevel={level}>
        {children}{' '}
        {required ? <span className={css({
        color: 'red'
      })}>*</span> : ''}
      </Heading>
    </HeadingLevel>;
};